import Vue from "vue";
import App from "./App.vue";
import './assets/js/zepto'
import './assets/js/layer_mobile/layer'

import router from "./router";
import store from "./store";
import "./assets/js/adaptive";
import "./assets/js/bridge-1.0.8.min";
// import "./assets/js/new_1";

// ------------2024-11-22⬇️---------------------
import './styles/index.less'
import FloatingVue from "floating-vue";
import strutAlignCenter from "./h5Components/cur-components/strut-align-center.vue";
import { Tab, Tabs, Icon, Card, Tag, Button,Image as VanImage,Loading,Rate,Popup, Swipe, SwipeItem,Popover } from "vant";
import "vant/lib/index.css";
import "floating-vue/dist/style.css";

Vue.use(Tab).use(Tabs).use(Icon).use(Card).use(Tag).use(Button).use(VanImage).use(Loading).use(Rate).use(Popup).use(FloatingVue).use(Swipe).use(SwipeItem).use(Popover);
Vue.component("strut-align-center", strutAlignCenter);

Vue.prototype.$onLaunched = new Promise((resolve) => {
  Vue.prototype.$isResolve = resolve
})
// ------------2024-11-22⬆️---------------------

import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);

if (!process.env.VUE_APP_interface.match(/test.api/)) {
  // console.log = () => {};
}

// 异步加载图片方法
import VueLazyLoad from "vue-lazyload";
Vue.use(VueLazyLoad, {
	preLoad: 1.3,
	// error:'//img61.ddimg.cn/upload_img/00610/h5m/book300-1597227204.png',
	error: "//img63.ddimg.cn/upload_img/00610/h5m/bg_pic-1597226866.png",
	loading: "//img63.ddimg.cn/upload_img/00610/h5m/bg_pic-1597226866.png",
	attempt: 10
});

import axios from "./assets/js/axios";
Vue.prototype.$axios = axios;

import * as sys from "./assets/js/index";
Vue.prototype.$sys = sys;

import toast from './components/ddtoast/toast'
Vue.prototype.$toast = toast;




router.beforeEach((to, from, next) => {
	// window.document.title = to.meta.title;
	let DD_client = {};
	if (sys.browser.inset && ((to.query.ct && to.query.cv) || (to.query.user_client && to.query.client_version))) {
		//app 小程序 快应用 在url获取 udid ct cv
    DD_client.permanent_id = to.query.permanent_id;
    DD_client.unionid = to.query.union_id;
    DD_client.ct = to.query.ct || to.query.user_client;
    DD_client.cv = to.query.cv || to.query.client_version;
    if(to.query.udid){
      DD_client.udid = to.query.udid;
      sys.cookie.set("MDD_sid", to.query.udid, { domain: '.dangdang.com' ,expires: 7 });
      sys.cookie.set("__permanent_id", DD_client.permanent_id, { domain: '.dangdang.com' ,expires: 7 });
      sys.cookie.set("MDD_permanent_id", DD_client.permanent_id, { domain: '.dangdang.com' ,expires: 7 });
    }else{
      let udid = sys.md5(new Date().getTime() + "" + sys.format.random(16));
      sys.cookie.set("MDD_sid", udid, { signed: false,httpOnly:false, domain: ".dangdang.com", expires: 7 });
      DD_client.permanent_id = sys.format.formatDate(new Date(), "YYYYMMDDHHmmss") + "" + sys.format.random(21);
      sys.cookie.set("__permanent_id", DD_client.permanent_id, { signed: false,httpOnly:false, domain: ".dangdang.com", expires: 7 });
      sys.cookie.set("MDD_permanent_id", DD_client.permanent_id, { signed: false,httpOnly:false, domain: ".dangdang.com", expires: 7 });
      DD_client.udid = udid
    }
    DD_client.ucid = to.query.ucid || ''
	} else {
		//触屏过来的 从cookie 获取
    let cookie_sid = sys.cookie.get("MDD_sid");
    // 触屏站全站统一使用__permanent_id
    DD_client.permanent_id = sys.cookie.get("__permanent_id");
    DD_client.ct = "touch";
    DD_client.cv = "1.0";
    if(to.query.unionid || to.query.union_id){
      const unionid = to.query.unionid || to.query.union_id || sys.cookie.get("MDD_unionid");
      DD_client.unionid = unionid
      sys.cookie.set("MDD_unionid", unionid, { domain: '.dangdang.com' ,expires: 1 });
    }else{
      DD_client.unionid = sys.cookie.get("MDD_unionid");
    }

    if(cookie_sid){
      DD_client.udid = cookie_sid
    }else{
      let udid = sys.md5(new Date().getTime() + "" + sys.format.random(16));
      sys.cookie.set("MDD_sid", udid, { signed: false,httpOnly:false, domain: ".dangdang.com", expires: 7 });
      DD_client.udid = udid
    }

    if (!DD_client.permanent_id) {
      DD_client.permanent_id = sys.format.formatDate(new Date(), "YYYYMMDDHHmmss") + "" + sys.format.random(21);
      sys.cookie.set("MDD_permanent_id", DD_client.permanent_id, { signed: false, httpOnly:false, domain: ".dangdang.com", expires: 7 });
      sys.cookie.set("__permanent_id", DD_client.permanent_id, { signed: false, httpOnly:false, domain: ".dangdang.com", expires: 7 });
    }
    DD_client.ucid = sys.cookie.get('MDD_ucid') || sys.cookie.get('MDD_token') || ''
	}
	DD_client.active = to.query.active || 1;
	sys.cookie.set("DD_client", DD_client, { domain: '.dangdang.com',expires: 1 });

  sys.cookie.set("MDD_user_client", DD_client.ct || 'touch', { domain: '.dangdang.com' ,expires: 7 });
  sys.cookie.set("MDD_client_version", DD_client.cv || '1.0', { domain: '.dangdang.com' ,expires: 7 });

	next();
});

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");


//  async function setUdid(ctx, next) {
//     let udid = ctx.cookies.get("MDD_sid", { signed:false});
//     if (!udid) {
//       //uidi 不存在生成一份
//       let udid = md5(new Date().getTime() + "" + format.random(16));
//       // let permanent_id = format.formatDate(new Date(), "YYYYMMDDHHmmss") + "" + format.random(21);
//       sys.cookie.set("MDD_sid", udid, { signed: false,httpOnly:false, domain: ".dangdang.com", expires: dayjs().add(10, "year").toDate() });
//       // ctx.cookies.set("MDD_permanent_id", permanent_id, { signed: false,httpOnly:false, domain: ".dangdang.com", expires: dayjs().add(10, "year").toDate() });
//
//       // ctx.cookies.set("MDD_province_id", "111", { signed: false,httpOnly:false, domain: ".dangdang.com", expires: dayjs().add(10, "year").toDate() });
//       // ctx.cookies.set("MDD_province_str", encodeURIComponent("北京"), { signed: false,httpOnly:false, domain: ".dangdang.com", expires: dayjs().add(10, "year").toDate() });
//       //
//       // ctx.cookies.set("MDD_city_id", "1", { signed: false,httpOnly:false, domain: ".dangdang.com", expires: dayjs().add(10, "year").toDate() });
//       // ctx.cookies.set("MDD_city_str", encodeURIComponent("北京市"), { signed: false,httpOnly:false, domain: ".dangdang.com", expires: dayjs().add(10, "year").toDate() });
//       //
//       // ctx.cookies.set("MDD_area_id", "1110101", { signed: false,httpOnly:false, domain: ".dangdang.com", expires: dayjs().add(10, "year").toDate() });
//       // ctx.cookies.set("MDD_area_str", encodeURIComponent("东城区"), { signed: false,httpOnly:false, domain: ".dangdang.com", expires: dayjs().add(10, "year").toDate() });
//     }
//     await next();
// };
